// extracted by mini-css-extract-plugin
export var textContainer = "roadmap-module--textContainer--2hbR0";
export var imageContainer = "roadmap-module--imageContainer--3mWdP";